import { render } from "./logout-success.vue?vue&type=template&id=cdf53d5e&scoped=true&ts=true&lang=pug"
import script from "./logout-success.vue?vue&type=script&lang=ts"
export * from "./logout-success.vue?vue&type=script&lang=ts"

import "./logout-success.vue?vue&type=style&index=0&id=cdf53d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf53d5e"]])

export default __exports__